// @flow

export const LIGHT_DARK = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
};

export type LightDark = $Keys<typeof LIGHT_DARK>;
